export default __webpack_public_path__ + "static/media/forbidden.e405de1d.svg";